module.exports = __webpack_public_path__ + "media/images/Fav-On-blue-42af1d23376ac880466d602b3da07f28.svg";